/* eslint-disable import/extensions */
import { auth } from '@/services/auth';
import InquiryQuick from './rapida/[type]';
import { http } from '@/helpers/index';

InquiryQuick.enableMessages = true;
export default InquiryQuick;

export async function getServerSideProps(context) {
  const { type } = context.query;

  const res = await http.baseAsync('GET', '/configurations');
  let warning = '';
  if (res.ok) {
    const item = await res.json();
    if (item && !item.vendors.checktudo.online) {
      warning = item.vendors.message;
    }
  }

  let typeOf = type;
  if (['leilao-completo', 'leilao', 'auction'].includes(type)) {
    typeOf = 'leilao-especial';
  }
  if (['indicio-sinistro', 'dados-nacionais', 'complete'].includes(type)) {
    typeOf = 'completa';
  }
  if (['special'].includes(type)) {
    typeOf = 'especial';
  }
  const resProduct = await http.baseAsync('GET', `/products/${typeOf}`, null, false, auth.headers());
  if (!resProduct.ok) { return { props: {}, }; }
  const product = await resProduct.json();

  return { props: { warning, product, }, };
}
